export const FORM_TYPES = {
  INSURANCE_ONLY: 'INSURANCE_ONLY_FORM',
  NONE: 'NONE',
  SWAP_AND_INSURANCE: 'SWAP_AND_INSURANCE_FORM',
  SWAP_ONLY: 'SWAP_ONLY_FORM',
} as const
